"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// wwwroot/ts/main.ts
var AuthenticationService_1 = require("./AuthenticationService");
window.AuthenticationService = AuthenticationService_1.AuthenticationService;
